import request from '@utils/axios-utils';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useAuth } from '@providers/auth';
import Notification from '@components/notification/notification';

export interface PaymentMethod {
  id: number;
  name: string;
  created_at: string;
  deleted_at: string | null;
}

export function usePaymentMethods() {
  const { session } = useAuth();
  return useQuery<{ data: PaymentMethod[] }>(
    ['payment_methods'],
    async () => {
      const response = await request({
        authorizationToken: session?.token,
        url: '/payment_methods',
        method: 'GET',
      });
      return response.data;
    },
    { enabled: session.status !== 'loading' },
  );
}

export function useCreatePaymentMethod() {
  const { session } = useAuth();
  const queryClient = useQueryClient();
  return useMutation(
    ({ name }: { name: string }) =>
      request({
        authorizationToken: session?.token,
        url: '/payment_methods',
        method: 'POST',
        data: { name },
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['payment_methods']);
        Notification({ type: 'success', message: 'Método de pago creado.' });
      },
      onError: (error: any) => {
        Notification({
          type: 'error',
          message: error.response?.data?.error?.message || 'Error al crear el método de pago.',
        });
      },
    },
  );
}

export function useDeletePaymentMethod() {
  const { session } = useAuth();
  const queryClient = useQueryClient();
  return useMutation(
    ({ id }: { id: number }) =>
      request({
        authorizationToken: session?.token,
        url: `/payment_methods/${id}`,
        method: 'DELETE',
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['payment_methods']);
        Notification({ type: 'success', message: 'Método de pago eliminado.' });
      },
      onError: () => {
        Notification({ type: 'error', message: 'Error al eliminar el método de pago.' });
      },
    },
  );
}
